import _ from 'lodash';

const SANITIZE_TYPES = {
    'TEXT_INPUT_TEXT': 'TEXT_INPUT_TEXT',
    'TEXT_INPUT_PASSWORD': 'TEXT_INPUT_PASSWORD',
    'TEXT_INPUT_NUMBER': 'TEXT_INPUT_NUMBER',
    'TEXT_INPUT_EMAIL': 'TEXT_INPUT_EMAIL',
    'TEXT_INPUT_URL': 'TEXT_INPUT_URL',
    'TEXT_INPUT_TEL': 'TEXT_INPUT_TEL',
    'TEXT_AREA': 'TEXT_AREA',
    'SELECT_INPUT': 'SELECT_INPUT',
    'RADIO_GROUP': 'RADIO_GROUP',
    'CHECKBOX_GROUP': 'CHECKBOX_GROUP',
    'CHECKBOX': 'CHECKBOX'
};
const ELEMENT_TYPES = {
    TEXT_INPUT: 'TextInput',
    TEXT_AREA: 'TextAreaInput',
    SELECT_INPUT: 'SelectableList',
    RADIO_GROUP: 'RadioGroup',
    CHECKBOX_GROUP: 'CheckboxGroup',
    CHECKBOX: 'CheckboxInput'
};
const TEXT_INPUT_TYPES = {
    TEXT: 'text',
    PASSWORD: 'password',
    NUMBER: 'number',
    EMAIL: 'email',
    URL: 'url',
    TEL: 'tel'
};
const ELEMENT_TYPE_TO_SANITIZE_TYPE = {
    [ELEMENT_TYPES.TEXT_INPUT]: {
        [TEXT_INPUT_TYPES.TEXT]: SANITIZE_TYPES.TEXT_INPUT_TEXT,
        [TEXT_INPUT_TYPES.PASSWORD]: SANITIZE_TYPES.TEXT_INPUT_PASSWORD,
        [TEXT_INPUT_TYPES.NUMBER]: SANITIZE_TYPES.TEXT_INPUT_NUMBER,
        [TEXT_INPUT_TYPES.EMAIL]: SANITIZE_TYPES.TEXT_INPUT_EMAIL,
        [TEXT_INPUT_TYPES.URL]: SANITIZE_TYPES.TEXT_INPUT_URL,
        [TEXT_INPUT_TYPES.TEL]: SANITIZE_TYPES.TEXT_INPUT_TEL
    },
    [ELEMENT_TYPES.TEXT_AREA]: SANITIZE_TYPES.TEXT_AREA,
    [ELEMENT_TYPES.SELECT_INPUT]: SANITIZE_TYPES.SELECT_INPUT,
    [ELEMENT_TYPES.RADIO_GROUP]: SANITIZE_TYPES.RADIO_GROUP,
    [ELEMENT_TYPES.CHECKBOX_GROUP]: SANITIZE_TYPES.CHECKBOX_GROUP,
    [ELEMENT_TYPES.CHECKBOX]: SANITIZE_TYPES.CHECKBOX
};

const validFloatingPointNumberRegExp = /^-?(\d+|\d+\.\d+|\.\d+)([eE][-+]?\d+)?$/;

const numberToString = (value) => {
    return _.isFinite(value) ? value.toString() : value;
};
const emptyStringIfNotString = (value) => {
    return _.isString(value) ? value : '';
};
const removeLineBreaks = (value) => value.replace(/(\r\n|\n|\r)/gm, "");
const removeLeadingAndTrailingWhitespace = (value) => value.trim();
const validFloatingPointNumber = (value) => {
    return validFloatingPointNumberRegExp.test(value) ? value : '';
};
const forceMaxLength = (compData) => (value) => {
    const maxLength = _.get(compData, 'maxLength', null);

    return maxLength ? value.substr(0, maxLength) : value;
};

const sanitizeForArray = (sanitizes) => {
    return _.flow(_.map(sanitizes, (sanitize) =>
        (arrValue) => _.map(arrValue, sanitize)
    ));
};

const normalizePrecision = (compData) => (value) => {
    const step = _.get(compData, 'step', null);

    if (_.isEmpty(value) || !step) {
        return value;
    }

    const normalizedStep = Number((Math.log(1 / step) / Math.log(10)).toFixed());
    return Number(value).toFixed(normalizedStep);
};

const getSanitizerByType = (sanitizeType, compData) => {
    switch (sanitizeType) {
        case SANITIZE_TYPES.TEXT_INPUT_TEXT:
            return _.flow([numberToString, emptyStringIfNotString, removeLineBreaks, forceMaxLength(compData)]);
        case SANITIZE_TYPES.TEXT_INPUT_PASSWORD:
            return _.flow([numberToString, emptyStringIfNotString, removeLineBreaks, forceMaxLength(compData)]);
        case SANITIZE_TYPES.TEXT_INPUT_NUMBER:
            return _.flow([numberToString, emptyStringIfNotString, validFloatingPointNumber, normalizePrecision(compData)]);
        case SANITIZE_TYPES.TEXT_INPUT_EMAIL:
            return _.flow([numberToString, emptyStringIfNotString, removeLineBreaks, removeLeadingAndTrailingWhitespace]);
        case SANITIZE_TYPES.TEXT_INPUT_URL:
            return _.flow([numberToString, emptyStringIfNotString, removeLineBreaks, removeLeadingAndTrailingWhitespace]);
        case SANITIZE_TYPES.TEXT_INPUT_TEL:
            return _.flow([numberToString, emptyStringIfNotString, removeLineBreaks]);
        case SANITIZE_TYPES.TEXT_AREA:
            return _.flow([numberToString, emptyStringIfNotString, forceMaxLength(compData)]);
        case SANITIZE_TYPES.SELECT_INPUT:
            return _.flow([numberToString, emptyStringIfNotString]);
        case SANITIZE_TYPES.RADIO_GROUP:
            return _.flow([numberToString, emptyStringIfNotString]);
        case SANITIZE_TYPES.CHECKBOX_GROUP:
            return sanitizeForArray([numberToString, emptyStringIfNotString]);
        case SANITIZE_TYPES.CHECKBOX:
            return _.flow([numberToString, emptyStringIfNotString]);
        default:
            return (value) => value;
    }
};

const getSanitizer = (compData) => {
    let elementType = compData.type;

    if (elementType === ELEMENT_TYPES.TEXT_INPUT){
        elementType += `.${compData.textType}`;
    }

    const sanitizeType = _.get(ELEMENT_TYPE_TO_SANITIZE_TYPE, elementType);

    return getSanitizerByType(sanitizeType, compData);
};

const valueSanitzationAlgorithm = (compData, value) => {
    const sanitizer = getSanitizer(compData);

    return sanitizer(value);
};

export default valueSanitzationAlgorithm;
